import apiClient from '@src/api/clients';

const BASE_URL = 'client-inbox/email-messages/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    ),
  );

export const listEmailMessages = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const retrieveEmailMessage = (id, params = {}) =>
  apiClient.request({ url: `${BASE_URL}${id}/`, method: 'GET', payload: cleanParams(params) });

export const updateEmailMessage = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/`, method: 'PATCH', payload });

export const listEmailSenders = () =>
  apiClient.request({ url: `${BASE_URL}senders/`, method: 'GET' });

export const replyToEmailMessage = (id, payload) =>
  apiClient.request({ url: `${BASE_URL}${id}/reply/`, method: 'POST', payload });

export const createBudgetConfirmations = (payload) =>
  apiClient.request({ url: `${BASE_URL}budget-confirmations/`, method: 'POST', payload });

export const inspectEmailThreadContext = (id, params = {}) =>
  apiClient.request({
    url: `${BASE_URL}${id}/inspect-context/`,
    method: 'GET',
    payload: cleanParams(params),
  });

export const regenerateEmailThreadDraft = (id) =>
  apiClient.request({
    url: `${BASE_URL}${id}/regenerate-draft/`,
    method: 'POST',
    payload: {},
  });

export default {
  listEmailMessages,
  retrieveEmailMessage,
  updateEmailMessage,
  listEmailSenders,
  replyToEmailMessage,
  createBudgetConfirmations,
  inspectEmailThreadContext,
  regenerateEmailThreadDraft,
};
